import { STEP_IDENTIFIER_NAME } from '../constants';
import type { StepConfig } from '../types';

const { ASK } = STEP_IDENTIFIER_NAME;

export const ask: StepConfig = {
	name: ASK,
	isAuthenticationRequired: false,
	isEnabled: () => true,
};
